import "./googlelogin.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  LOGIN_URL,
  CHECK_AUTHENTICATION_URL,
  PARENT_DOMAIN,
} from "../../constants/Constants";
import Cookies from "js-cookie";
import { CircularProgress } from "@mui/material";
import { Google3 } from "@emotion-icons/icomoon/Google3";
import { useAuth } from "../../context/AuthContext";
import DataSevices from "../../Services/DataSevices";

export default function Home() {
  const [gWaitOn, setGWaitOn] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();
  const { login, logout } = useAuth();

  useEffect(() => {
    fetchData().catch(() => {});
  }, []);

  useEffect(() => {
    if (errMsg) {
      const timer = setTimeout(() => setErrMsg(""), 4000);
      return () => clearTimeout(timer);
    }
  }, [errMsg]);

  const handleClick = () => {
    setGWaitOn(true);
    Cookies.set("loginButton", "zoom", {
      expires: 1,
      domain: PARENT_DOMAIN,
      path: "/",
    });
  };

  const fetchData = async () => {
    Cookies.remove("loginButton", {
      path: "/",
      domain: PARENT_DOMAIN,
    });

    setGWaitOn(true);

    try {
      // Replace with actual API
          const response = await fetch(CHECK_AUTHENTICATION_URL, {
            method: "GET",
            credentials: "include",
          }).catch((e) => {
            setErrMsg("please sign In...");
            setGWaitOn(false);
            logout();
          });

          const userData = await response.json();

      login(userData);
      sessionStorage.setItem("userEmail", userData.userEmail);
      sessionStorage.setItem("userName", userData.userName);

     DataSevices.getParticipantsInfo(userData.userEmail)
      .then((res) => {
        if (!res.data) {
          // If API returns null or no participant found
          navigate("/registration", { state: { participantInfo: res.data } });
        } else {
           if(res.data.whatsApp==null){
                // If participant found but whatsapp number is null
                 navigate("/registration", { state: { participantInfo: res.data } });
           }
           else {
              // If participant found
              navigate("/dashboard");
            }
        }
  })
  .catch((err) => {
    // On error, you may want to show an error or also navigate to registration
    console.log("error htne", err);
  });

    } catch (e) {
      setErrMsg("Please sign in...");
      logout();
    } finally {
      setGWaitOn(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">

        {/* Logo */}
        <img
                  src="../GVS.ico"
                  alt="logo"
                  className="logo"
                />
        <img
          src="../zoomlogo.png"
          alt="logo"
          className="logo"
        />

        <h2 className="title">Gauranga Vedic Society</h2>
         <h6>📿 Zoom Japa Attendance</h6>
                <p className="subtitle">
                  Track your daily chanting with devotion 🙏
                </p>
        <p className="subtitle">
          Login with your Google Account to continue
        </p>

        {errMsg && <p className="error">{errMsg}</p>}

        {gWaitOn ? (
          <div className="loader">
            <CircularProgress size={50} />
          </div>
        ) : (
          <button
            className="google-btn"
            onClick={() => {
              handleClick();
              window.location.href = LOGIN_URL;
            }}
          >
            <Google3 size={22} />
            <span>Sign in with Google</span>
          </button>
        )}
      </div>

    </div>
  );
}
